'use client';

import { Tabs } from '@mui/material';
import { usePathname } from 'next/navigation';
import type { FC, PropsWithChildren } from 'react';
export const TabsWrapper: FC<PropsWithChildren> = props => {
  const {
    children
  } = props;
  const pathname = usePathname();
  return <Tabs variant="fullWidth" value={pathname} data-sentry-element="Tabs" data-sentry-component="TabsWrapper" data-sentry-source-file="tabs-wrapper.tsx">
      {children}
    </Tabs>;
};